export const CREATE_BUSINESS = 'CREATE_BUSINESS';
export const CREATE_BUSINESS_FAILED = 'CREATE_BUSINESS_FAILED';
export const REQUEST_BUSINESS = 'REQUEST_BUSINESS';
export const RECEIVE_BUSINESS = 'RECEIVE_BUSINESS';
export const REQUEST_BUSINESS_FAILED = 'REQUEST_BUSINESS_FAILED';

export const REQUEST_SHIFTS = 'REQUEST_SHIFTS';
export const RECEIVE_SHIFTS = 'RECEIVE_SHIFTS';

export const REQUEST_JOBS = 'REQUEST_JOBS';
export const RECEIVE_JOBS = 'RECEIVE_JOBS';

export const SET_TITLE = 'SET_TITLE';

export const REQUEST_MANAGERS = 'REQUEST_MANAGERS';
export const RECEIVE_MANAGERS = 'RECEIVE_MANAGERS';

export const CREATE_SHIFT = 'CREATE_SHIFT';
export const CREATE_SHIFT_SUCCESS = 'CREATE_SHIFT_SUCCESS';
export const CREATE_SHIFT_FAILED = 'CREATE_SHIFT_FAILED';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT = 'LOGOUT';

export const RECEIVE_USER = 'RECEIVE_USER';



// WEBPACK FOOTER //
// ./src/state/actionTypes.js